import {
  SINGLE_LOAN_REQUEST_ERROR,
  SINGLE_LOAN_REQUEST_START,
  SINGLE_LOAN_REQUEST_SUCCESS,
} from 'constants/action-types/loanRequests/singleLoanRequest';
import notification from 'helpers/notificationHelper';
import apiAction from 'helpers/apiAction';

export default requestId => dispatch =>
  dispatch(
    apiAction({
      url: `/groups/microloans/requests/${requestId}`,
      method: 'GET',
      API_REQUEST_START: SINGLE_LOAN_REQUEST_START,
      API_REQUEST_SUCCESS: SINGLE_LOAN_REQUEST_SUCCESS,
      API_REQUEST_FAILURE: SINGLE_LOAN_REQUEST_ERROR,
      callbackOnFailure: ({ message }) =>
        notification({ message, status: 'error' }),
      onEnd: () => false,
    }),
  );
